import React from 'react'
import { LockClosedIcon } from '@heroicons/react/24/outline'

/**
 * Wyniki asystenta doboru bez konta (FE-08, decyzja właściciela 2026-10-19): widać jeden zestaw, najtańszy,
 * a pozostałe warianty („Najwyższej jakości” i inne) są za darmowym kontem. To zasłona interfejsu: backend
 * liczy wszystkie warianty jak dotąd, a ukrytych kart nie renderujemy wcale (same nazwy wariantów).
 */

/** Rozdziela warianty na widoczny bez konta (najtańszy, a bez niego pierwszy) i resztę. */
export const podzielWarianty = (warianty = []) => {
  if (!warianty.length) return { widoczne: [], ukryte: [] }
  const najtanszy = warianty.find((v) => v.variant === 'cheapest') || warianty[0]
  return { widoczne: [najtanszy], ukryte: warianty.filter((v) => v !== najtanszy) }
}

const odmianaZestawow = (n) => {
  if (n === 1) return '1 zestaw'
  const r10 = n % 10
  const r100 = n % 100
  return r10 >= 2 && r10 <= 4 && (r100 < 12 || r100 > 14) ? `${n} zestawy` : `${n} zestawów`
}

/** Karta w miejscu ukrytych wariantów: ich nazwy i przycisk do okna rejestracji. */
export const ZestawyZaKontem = ({ ukryte, onZalozKonto }) => {
  if (!ukryte?.length) return null
  return (
    <div className="flex flex-col justify-center rounded-2xl border border-dashed border-gray-300 bg-white p-6 text-center
                    dark:border-gray-600 dark:bg-gray-900">
      <span className="mx-auto mb-3 inline-flex h-10 w-10 items-center justify-center rounded-xl bg-blue-50 text-blue-600">
        <LockClosedIcon className="h-5 w-5" aria-hidden="true" />
      </span>
      <p className="text-base font-bold text-gray-900 dark:text-gray-100">
        Jeszcze {odmianaZestawow(ukryte.length)} na darmowym koncie
      </p>
      <p className="mt-1 text-sm text-gray-600 dark:text-gray-300">
        {ukryte.map((v) => v.variant_label_pl || v.variant).filter(Boolean).join(', ')}
      </p>
      <button type="button" onClick={onZalozKonto}
              className="mx-auto mt-4 rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-blue-500">
        Załóż darmowe konto, żeby zobaczyć wszystkie zestawy
      </button>
    </div>
  )
}

export const TEKSTY_OKNA_DOBORU = {
  zestawy: {
    tytul: 'Załóż darmowe konto, żeby zobaczyć wszystkie zestawy',
    opis: 'Na darmowym koncie zobaczysz każdy wariant doboru i dobierzesz zestaw bez limitu. Wystarczy e-mail i hasło.',
  },
  limit: {
    tytul: 'Załóż darmowe konto, żeby dobrać kolejny zestaw',
    opis: 'Bez konta dobierzesz zestaw raz. Na darmowym koncie dobierasz bez limitu i widzisz wszystkie warianty.',
  },
}
